import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import { CustomToggle } from "./CustomToggle";
import { CustomDropdown } from "./CustomDropdown";

export function DropdownSearchFilter(props) {
    const [value, setValue] = useState(null);
    return (
        <>
            <Dropdown
                className="form-group form-group-dropdown-filter"
                onBlur={props.onBlur ? props.onBlur : null}>
                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                    {
                        props.employeeName
                            &&
                            props.employeeName.employeeName ? props.employeeName.employeeName : <p className="text-muted">{props.message}</p>
                    }
                    <FontAwesomeIcon icon={faAngleDown} />
                </Dropdown.Toggle>

                <Dropdown.Menu as={CustomDropdown}>
                    {
                        props.data.map((project, index) => (
                            <Dropdown.Item
                                key={index}
                                onClick={() => {
                                    props.setEmployeeName(project);
                                    props.setError(false);
                                }}>
                                {project.employeeName}
                            </Dropdown.Item>
                        ))}
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}
